import { Loader, Button, Heading } from "@bfc-software/pallet";
import {
  useTranslation,
  TRANSLATION_NAMESPACE,
  DEFAULT_LOCALE,
} from "@bfc-software/bfc-web-ui/i18n";

import { GoBack } from "../-utilities/login-form-state";

import UserName from "./user-name";
import LoginCard from "./login-card";
import styles from "./request-orgs.module.css";

interface RequestOrgsProps {
  lang: string;
  email?: string;
  goBack: GoBack;
}

export default function RequestOrgs({ lang, email, goBack }: RequestOrgsProps) {
  const { t } = useTranslation({
    lang: lang || DEFAULT_LOCALE,
    namespace: TRANSLATION_NAMESPACE.login,
  });
  return (
    <LoginCard data-testid="request-orgs">
      <Heading text={t("locSelectionTitle")} level="1" />
      {email && <UserName>{email}</UserName>}
      <Loader className={styles.loading} />
      {goBack.shouldRender && (
        <Button
          icon={{ type: "arrow-left" }}
          onPress={goBack.handler}
          variant="tertiary"
          text={goBack.label}
          type="submit"
        />
      )}
    </LoginCard>
  );
}
